import { useAuthStore } from "../store/authStore";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "https://api.hockeyfightchronicles.com/api/v1";
export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const refreshToken = async () => {
  const refreshToken = useAuthStore.getState().refreshToken;
  try {
    const { data } = await axios.post(
      `${BASE_URL}/auth/refresh-token`,
      { refreshToken }, // body
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${refreshToken}`, // optional if your API needs it
        },
      }
    );

    useAuthStore.getState().setUser(data?.data?.user);
    useAuthStore.getState().setToken(data?.data?.accessToken);
    useAuthStore.getState().setRefreshToken(data?.data?.refreshToken);
  } catch (error) {
    console.error("Token refresh error", error);
  }
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._isRetry) {
      try {
        originalRequest._isRetry = true;
        const headers = { ...originalRequest.headers };
        await refreshToken();
        return api.request({ ...originalRequest, headers });
      } catch (err) {
        console.error("Token refresh error", err);
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);
